import {LBL_VAL_CLADD_COMM_ERR, LBL_VAL_CLADD_RATECARD, LBL_VAL_CLDET_COMM_ERR, LBL_VAL_CLDET_HEADER, LBL_PRIMARY_CONTACT, LBL_BANK_DETAILS, LBL_ADDITIONAL_INFO,LBL_SKILL_DOCUMENTS, LBL_DOCUMENTS, LBL_VAL_EVADD_COMM_ERR, LBL_VAL_EVADD_HEADER, LBL_CLIENTS, LBL_PAY_LEVEL, LBL_CREW, LBL_SKILLS, LBL_VAL_CREWADD_COMM_ERR, LBL_VAL_CREWADD_HEADER, LBL_VAL_CREWDET_COMM_ERR, LBL_VAL_CREWDET_HEADER, LBL_HEALTH_INFO, LBL_INDUCTION_MUST_COMPLETED, LBL_APPRVD_BY_AFFILIATE, LBL_EMAIL_MUST_VERIFIED, LBL_AVAILABLE_FOR_SCHEDULE } from './labelConfigs'; 

export const validationMsgClientAdd = {
    "common_error":LBL_VAL_CLADD_COMM_ERR,
    "master_ratecard":LBL_VAL_CLADD_RATECARD
};  

export const validationMsgClientDetails = {
    "common_error":LBL_VAL_CLDET_COMM_ERR, 
    "common_header":LBL_VAL_CLDET_HEADER, 
    "primary_contact":'<li style="list-style-type:none;">* '+LBL_PRIMARY_CONTACT+'</li>', 
    "bank_details":'<li style="list-style-type:none;">* '+LBL_BANK_DETAILS+'</li>', 
    "additional_info":'<li style="list-style-type:none;">* '+LBL_ADDITIONAL_INFO+'</li>', 
    "documents_START":'<li style="list-style-type:none;">* '+LBL_DOCUMENTS+' - ', 
    "documents_END":'</li>'
}; 

export const validationMsgEventAdd = {
    "common_error":LBL_VAL_EVADD_COMM_ERR, 
    "common_header":LBL_VAL_EVADD_HEADER, 
    "clients":'<li style="list-style-type:none;">* '+LBL_CLIENTS+'</li>', 
    "paylevels":'<li style="list-style-type:none;">* '+LBL_PAY_LEVEL+'</li>', 
    "crews":'<li style="list-style-type:none;">* '+LBL_CREW+'</li>', 
    "skills":'<li style="list-style-type:none;">* '+LBL_SKILLS+'</li>'
};  

export const validationMsgCrewAdd = {
    "common_error":LBL_VAL_CREWADD_COMM_ERR, 
    "common_header":LBL_VAL_CREWADD_HEADER, 
    "paylevels":'<li style="list-style-type:none;">* '+LBL_PAY_LEVEL+'</li>', 
    "skills":'<li style="list-style-type:none;">* '+LBL_SKILLS+'</li>'
}; 

export const validationMsgCrewDetails = {
    "common_error":LBL_VAL_CREWDET_COMM_ERR, 
    "common_header":LBL_VAL_CREWDET_HEADER, 
    "not_inducted":'<li style="list-style-type:none;">* '+LBL_INDUCTION_MUST_COMPLETED+'</li>', 
    "not_approved":'<li style="list-style-type:none;">* '+LBL_APPRVD_BY_AFFILIATE+'</li>', 
    "not_available_for_schedule":'<li style="list-style-type:none;">* '+LBL_AVAILABLE_FOR_SCHEDULE+'</li>', 
    "email_not_verified":'<li style="list-style-type:none;">* '+LBL_EMAIL_MUST_VERIFIED+'</li>', 
    "bank_details":'<li style="list-style-type:none;">* '+LBL_BANK_DETAILS+'</li>', 
    "additional_info":'<li style="list-style-type:none;">* '+LBL_ADDITIONAL_INFO+'</li>', 
    "health_info":'<li style="list-style-type:none;">* '+LBL_HEALTH_INFO+'</li>', 
    "documents_START":'<li style="list-style-type:none;">* '+LBL_DOCUMENTS+' - ', 
    "documents_END":'</li>',
    "skill_documents_START":'<li style="list-style-type:none;">* '+LBL_SKILL_DOCUMENTS+' - ', 
    "skill_documents_END":'</li>',
}; 




  
  
